module.exports = __webpack_public_path__ + "static/media/IMG_20190212_135106.92377f42.jpg";